var AxisPlacement = {
  UNSPECIFIED: {
    id: 0,
    name: 'UNSPECIFIED',
    toString: function toString() {
      return 'UNSPECIFIED';
    }
  },
  RIGHT: {
    id: 1,
    name: 'RIGHT',
    toString: function toString() {
      return 'RIGHT';
    }
  },
  LEFT: {
    id: 2,
    name: 'LEFT',
    toString: function toString() {
      return 'LEFT';
    }
  },
  BOTH: {
    id: 3,
    name: 'BOTH',
    toString: function toString() {
      return 'BOTH';
    }
  },
  BOTTOM: {
    id: 4,
    name: 'BOTTOM',
    toString: function toString() {
      return 'BOTTOM';
    }
  },
  TOP: {
    id: 5,
    name: 'TOP',
    toString: function toString() {
      return 'TOP';
    }
  }
};
export default AxisPlacement;